import { collection, getDocs, query, where } from "firebase/firestore";
import { dbFirebase } from "../Conections/Firebase";

export const mapSnapshot = (snapshot) =>
  snapshot.docs.map((docItem) => ({ id: docItem.id, ...docItem.data() }));

export const fetchCollection = async (name) => {
  const snapshot = await getDocs(collection(dbFirebase, name));
  return mapSnapshot(snapshot);
};

export const fetchWhere = async (name, field, op, value) => {
  const snapshot = await getDocs(query(collection(dbFirebase, name), where(field, op, value)));
  return mapSnapshot(snapshot);
};
